import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;
const token = Cookies.get("authToken");

const DataBase = Cookies.get("Database");
const ProjectIDs = 1;


// ========== Thunks ==========

export const FundMonthWise = createAsyncThunk(
    'TrialBalance/FundMonthWise',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/TrialBalance/FundMonthWise`, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                BankIDs: data.selectedIds1 || "",
                AcIDs: data.AcIDs || "",
                AcGroupIDs: data.selectedIds || "",
                MonthName: data.MonthName || "",
            }, {
                headers: {
                    token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data || 'Network Error');
        }
    }
);

export const FundGroupWise = createAsyncThunk(
    'TrialBalance/FundGroupWise',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/TrialBalance/FundGroupWise`, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                AcGroupIDs: data.selectedIds || "",
                AcIDs: data.AcIDs || "",
                IdxMonthNames: data.IdxMonthNames || "",

            }, {
                headers: {
                    token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data || 'Network Error');
        }
    }
);

export const BankList = createAsyncThunk(
    'TrialBalance/BankList',
    async () => {
        try {
            const response = await axios.post(`${BaseURL}/TrialBalance/BankList`, {
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,

            }, {
                headers: {
                    token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data || 'Network Error');
        }
    }
);

export const FundWithoutGroupWise = createAsyncThunk(
    'TrialBalance/FundWithoutGroupWise',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/TrialBalance/FundWithoutGroupWise`, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                AcGroupIDs: data.selectedIds || "",
                AcIDs: data.AcIDs || "",
                IdxMonthNames: data.IdxMonthNames || "",
            }, {
                headers: {
                    token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data || 'Network Error');
        }
    }
);

// ========== Slice ==========

export const FundFlowSlice = createSlice({
    name: 'FAS',
    initialState: {
        FundMonthWisedata: null,
        FundGroupWisedata: null,
        BankListdata: null,
        WithoutGroupWisedata: null,
        status: 'idle',
        error: null,
    },
    reducers: {
        FondMonthwiseFan: (state) => {
            state.FundMonthWisedata = 'no';
        },
        FondGroupwiseFan: (state) => {
            state.FundGroupWisedata = 'no';
        },
        FondwithoutGroupwiseFan: (state) => {
            state.WithoutGroupWisedata = 'no';
        },
    },
    extraReducers: (builder) => {
        builder
            // First FundGroupWise
            .addCase(FundMonthWise.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(FundMonthWise.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.FundMonthWisedata = action.payload;
            })
            .addCase(FundMonthWise.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(FundGroupWise.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(FundGroupWise.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.FundGroupWisedata = action.payload;
            })
            .addCase(FundGroupWise.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            // BankList
            .addCase(BankList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(BankList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.BankListdata = action.payload;
            })
            .addCase(BankList.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            // FundWithoutGroupWise
            .addCase(FundWithoutGroupWise.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(FundWithoutGroupWise.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.WithoutGroupWisedata = action.payload;
            })
            .addCase(FundWithoutGroupWise.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    },
});

export const { FondwithoutGroupwiseFan, FondGroupwiseFan, FondMonthwiseFan } = FundFlowSlice.actions;
export default FundFlowSlice.reducer;
